import { withQuestionnaireFuncs } from 'Context/WithQuestionnaireAnswer';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'Helpers/PropTypes';
import { withHousehold } from 'Context/HouseholdContext';

import { ContextIndex } from './FieldList';
import './index.css';
import withViewContext from './withViewContext';

class Value extends Component {
  constructor(props) {
    super(props);

    const {
      apiResponse: {
        attributes: { value },
      },
    } = props;

    this.state = {
      value,
      isDone: false,
    };
  }

  componentDidMount() {
    const {
      householdId,
      answerKey,
      getQuestionnaireAnswer,
      getIndexedQuestionnaireAnswer,
    } = this.props;
    const index = this.context;

    let promise;
    if (index > -1) {
      promise = getIndexedQuestionnaireAnswer(householdId, answerKey, index);
    } else {
      promise = getQuestionnaireAnswer(householdId, answerKey);
    }

    return promise
      .then((res) => this.setState({ value: res.attributes.value }))
      .finally(() => this.setState({ isDone: true }));
  }

  render() {
    const { OnMountRender } = this.props;
    const { value, isDone } = this.state;

    if (!isDone) {
      return null;
    }

    return (
      <div>
        <OnMountRender value={value} />
      </div>
    );
  }
}

Value.contextType = ContextIndex;

Value.propTypes = {
  apiResponse: PropTypes.instanceOf(Object),
  OnMountRender: PropTypes.func,
  getQuestionnaireAnswer: PropTypes.func.isRequired,
  getIndexedQuestionnaireAnswer: PropTypes.func.isRequired,
  householdId: PropTypes.number.isRequired,
  answerKey: PropTypes.string.isRequired,
};

Value.defaultProps = {
  OnMountRender: noop,
  apiResponse: { attributes: {} },
};

const FetchValue = withHousehold(withQuestionnaireFuncs(withViewContext(Value)));

export default FetchValue;
